import EventEmitter from 'events';
// import View from './js/views/shop-the-look-pdp';
import PageApp from 'pageApp';
import './scss/shop-the-look-pdp.scss';
import ModalOverlay from '@component/modal-overlay';
import $ from 'jquery';
import Backbone from 'backbone';
import Model from './js/models/shop-the-look-pdp';
import ProductModel from '@page/digital-product-ui-mcom/src/js/ProductModel';
// import template from '../src/templates/views/shop-the-look-pdp.hbs';
import templatepdp from '../src/templates/views/popup-container.hbs';
import CarouselSlideShow from '@component/carousel/src/views/HorizontalCarousel';
import { Actions as ProductDetailsActions } from '@page/digital-product-ui-mcom/src/js/util/Constants';
import { onAddToBagClick, onAddToBagSuccess } from '@page/digital-product-ui-mcom/src/js/listeners/AddToBagListeners';
import { onAddToListClick, onAddToListSuccess } from '@page/digital-product-ui-mcom/src/js/listeners/AddToListListeners';
import { onAddToRegistryClick, onAddToRegistrySuccess } from '@page/digital-product-ui-mcom/src/js/listeners/AddToRegistryListeners';
import { getProductView } from  '../src/js/views/pdp-loader.js';
import '@page/digital-product-ui-mcom/src/scss/main.scss'
import '@page/digital-product-ui-mcom/src/scss/member-product.scss'
import '@page/digital-product-ui-mcom/src/scss/master-product.scss'
import Loader from '@component/loader/src/js/views/loader';
import TagManager from '@component/common/src/util/TagManagerUtil';
import Notification from '@component/notification';
import CookieUtil from '@component/common/src/util/Cookie.js';
import Properties from '@page/digital-product-ui-mcom/src/js/util/Properties';
import {clientSideExperimentationFlags} from "@page/digital-product-ui-mcom/src/js/util/ExperimentationUtil.js"
import _ from 'lodash';
let loader  = new Loader("body");
let self;
// let $window  = window;
export default class Component extends EventEmitter {
  constructor(el, options) {
    super(); // calls EventEmitter's constructor
    self = this;
    this.model = new Model();
    this.options = options;
    this.getProducts.bind(this);
    this.$window = window;
    this.karmatrig = false;
    if (typeof utag_data == 'undefined') {
      utag_data = {
        page_name: "imp-sitelet"
      }
    }
    if (!!!window.$) {
      window.$ = $;
    }
  }

  quantityText(args){
    console.log('quantitytest>>>>',args);
    try {
      if (args.responseData.bag.meta.analytics.data.product_quantity[0] != 1) {
        return args.responseData.bag.meta.analytics.data.product_quantity[0] + " Item(s) added to bag"
      } else {
        return 'Item added to bag'
      }
    } catch (e){}
  }

  triggerTag(args) {
    console.log('triggerTag>>>>>', args);
    var data = Object.assign({}, args.productModel.get('utagData'));
    try {
      if (Object.keys(data).length === 0) {
        data = {
          // "is_responsive_pdp": "true",
          // "eligible_attribute_count": "zero",
          // "page_type": "sitelet",
          "t_category_id": [
            args.productModel.get('product').relationships.taxonomy.defaultCategoryId.toString()
          ],
          "t_category_name": [
            args.productModel.get('product').detail.typeName
          ],
          "is_big_ticket": [
            args.productModel.get('product').detail.flags.bigTicketItem.toString()
          ],
          "is_big_ticket_v2c": [
            args.productModel.get('product').detail.flags.bigTicketV2CItem.toString()
          ],
          "product_id": [
            args.productModel.get('product').id.toString()
          ],
          // "product_low_availability": [
          //   "false"
          // ],
          // "product_availability_message": [
          //   "This product is currently unavailable"
          // ],
          "product_name": [
            args.productModel.get('product').detail.name
          ],
          // "product_type": [
          //   "single item"
          // ],
          // "product_original_price": [
          // ],
          // "product_price": [
          // ],
          // "product_pricing_state": [
          //   ""
          // ],
          // "product_rating": [
          //   productModel.get('product').reviewStatistics"3.6667"
          // ],
          // "product_reviews": [
          //   "3"
          // ],
          // "product_video": [
          //   "false"
          // ],
          // "product_gwp_available": [],
          // "product_pwp_available": [],
          // "true_fit_eligible": [
          //   "true"
          // ],
          // "findation_eligible": [
          //   "false"
          // ],
          "product_brand": [
            args.productModel.get('product').detail.brand.name
          ],
          // "consolidated_product": "false",
          // "gdp_eligible": "false",
          // "event_name": "shop the look"
        }
        if (args.productModel.get('product').pricing) {
          try {
            args.productModel.get('product').pricing.price.tieredPrice.forEach((p) => {
              if (p.values[0].type == 'regular') {
                data.product_price = [p.values[0].value.toString()]
              } else if (p.values[0].type == 'discount') {
                data.product_original_price = data.product_price;
                data.product_price = [p.values[0].value.toString()];
              }
            })
            if (args.productModel.get('product').pricing.price.finalPrice) {
              data.product_original_price = data.product_price;
              data.product_price = [productModel.get('product').pricing.finalPrice.values[0].value];
            }
          } catch (e) {
          }

        }
      }
    } catch(e){ console.log(e,'err in tracking')};
      var newData  = Object.assign(data, {
        page_type: 'sitelet',
        event_name: args.source == 'PDPA2B' ? 'add to list' : 'add to bag',
      });
      if (args.source !== 'PDPA2B') {
        $('[data-auto="add-to-bag"]').text('View Bag & Checkout').css({'white-space': 'nowrap','padding-left': 0,'padding-right': 0}).wrapAll("<a href='/my-bag' class='a2bbutton'></a>").removeAttr('data-action').removeAttr('data-auto');

        self.notification = new Notification({
          selector: '[data-el="cta-notification"]',
          el: document.querySelector('[data-el="cta-notification"]'),
          id: 'cta-notification-atb',
          content: self.quantityText(args),
          style: 'valid',
          brand: 'mcom',
          destroyOnClose: true,
        });
      }
      TagManager.fireTag('link', newData);
  }

  removeDefaultSelected(event,model){
    // console.log('removeDefaultSelected',event,$(event.currentTarget).siblings(), $(event.currentTarget).find('.color-swatch-div').attr('data-color-id'))
    this.colorg({color:$(event.currentTarget).find('.color-swatch-div').attr('data-color-id')},self.model.get('pdp'))
    setTimeout(this.removeDefaultSelectedInner.bind(this,event),10)
  }
  removeDefaultSelectedInner(event){
    $('.color-swatch-div[data-color-id]').each(function(i,el){
      // console.log('removeDefaultSelected', el, $(el).data('color-id'))
      if ($(el).data('color-id') != $(event.currentTarget).find('.color-swatch-div').attr('data-color-id')) {
        $(el).removeClass('selected').removeAttr('aria-selected').addClass('tested');
      }
    })
  }

  init(){
    PageApp.channel.on(ProductDetailsActions.product.view.update, this.updateProd);
    PageApp.channel.on(ProductDetailsActions.product.bag.add, onAddToBagClick);

    PageApp.channel.on(ProductDetailsActions.product.bag.success, onAddToBagSuccess);
    PageApp.channel.on(ProductDetailsActions.product.bag.success, this.triggerTag);

    PageApp.channel.on(ProductDetailsActions.product.list.add, onAddToListClick);
    PageApp.channel.on(ProductDetailsActions.product.list.add, this.triggerTag);

    PageApp.channel.on(ProductDetailsActions.product.list.success, onAddToListSuccess);
    PageApp.channel.on(ProductDetailsActions.product.registry.add, onAddToRegistryClick);
    PageApp.channel.on(ProductDetailsActions.product.registry.success, onAddToRegistrySuccess);

    //reinit video
    PageApp.channel.on(ProductDetailsActions.tealium.linkTag, this.brightcoveappend);
    PageApp.channel.on(ProductDetailsActions.tealium.linkTag, this.hideArrow);

    // PageApp.channel.on(Actions.product.mainImageLoad.onLoadComplete, this.hideArrow);

    document.addEventListener('click', this.closeModal, true);
    document.addEventListener('click', this.videoLauncher, true);
    document.addEventListener('click', this.altImg, true);
    document.addEventListener('click', this.changeProduct, true);
    document.addEventListener('click', this.renderContent, true);

    $(document).on({click:this.removeDefaultSelected.bind(this)}, '.color-swatch');

    // console.log('init',self, this);
    self.overlay = new ModalOverlay({
      id: "pdp-overlay-id",
      contentContainer: document.querySelector('.overlay-content-container'),
      titleContainer: document.querySelector('.overlay-header'),
      header: true,
      title: "",
      content: "blah"
    });
  }

  videoLauncher(event){
    if (event.target.classList.contains('launch-video-btn')) {
        setTimeout(
          self.vid.bind(this,event)
          ,1000);
    }
  }
  vid(event){
    // console.log(event, 'vid');
    //   setTimeout(function(){
        if (document.querySelector('#product-video-overlay video')) {
          var vid = document.querySelector('#product-video-overlay video').id;
          if (vid.indexOf('-') == -1) {
            var rand = Math.round(Math.random() * 10);
            document.querySelector('#product-video-overlay video').id = vid + '-' + rand;
            bc(vid + '-' + rand);
          }
        }
      // },1000)

  }

  overlayRender(content, action){
    console.log('>>>>>overlayRender', content);
    self.buildProductDetailsPage(content);
    if (!action) {
      self.overlay.setContent(templatepdp(content));
      self.slideShow =  new CarouselSlideShow({
        el: "#pdp-horizontal-holder",
        ssr: true,
      });
      self.slideShow.render();
      $('.pdp-thumb').first().addClass('selected');
    } else {

    }

    self.overlay.open();
    loader.hide();
    // if (content.color){
    //   $('option[data-color-id="'+content.color+'"]').click();
    // }

    try {
      setTimeout(()=>{
        if ($('[data-el="sizes"] .swatch-itm').length > 4) {
          $('[data-el="sizes"] .vw-more').removeClass('invisible');
        }
      },200)

    } catch(e){}

  }
  closeModal(event){
    if (event.target.classList.contains('overlay-close-btn')) {
      if (bc) {
        try {
          bc.videojs.getAllPlayers()[0].pause();
        } catch(e){}
      }
    }
  }

  changeProduct(event){
    console.log('CHANGE PRODUCT', event, self)
    if (event.target.dataset.pdpid) {
      $('.pdp').replaceWith('');
      $(event.target).closest('.pdp-thumb').addClass('selected').siblings().removeClass('selected');
      let newObj = Object.assign({},self.model.attributes.list);
      newObj.product = self.filtered(newObj, event).product;
      console.log('self.modelp-----',self.model, self.model.get('pdp'))
      self.model.set('featureEligible', self.model.get('pdp').attributes.featureEligible);
      self.overlayRender(newObj, 'clicked')
    }
  }

  filtered(obj, event, check){
    if (obj.product){
      obj.product = obj.product.filter((el) => { return self.check(el, event) });
      return obj;
    } else {
      obj.product = [];
      return obj;
    }
  }

  check(obj, event){
    return obj.id == event.target.dataset.pdpid
  }

  renderContent(event){
    if (event.target.classList.contains('not-shop-the-look')) {
      //do nothing
      event.stopPropagation();
    } else if(CookieUtil.get('ishop_app')) {
      if (event.target.dataset.pdpids || self.karmatrig) {
        event.stopPropagation();
        window.open('/shop/featured/' + event.target.dataset.pdpids, "_blank");
      }
    } else if (event.target.dataset.pdpids) {
      // console.log('shop the look activate')
      loader.show();
      self.getProducts(event)
        .then(self.overlayRender);
    } else {

    }
  }

  getProducts(event) {

    var parts = [];
    var ids = event.target.dataset['pdpids'].split(',');
    var color = event.target.dataset['colorId'];

    // if (ids.length >= 6) {
    //   var third = Math.ceil(ids.length/3);
    //   parts.push(ids.splice(0,third));
    //   parts.push(ids.splice(0,third));
    //   parts.push(ids.concat(['2816938']));
    // } else if (ids.length>1){
    //   var half = Math.ceil(ids.length/2);
    //   parts.push(ids.splice(0,half));
    //   parts.push(ids.concat(['2816938']));
    // } else {
    //   // 2816938
    //   parts.push(ids);
    //   parts.push(ids.concat(['2816938']));
    // }
    var ajaxes = [];
    _.each(ids, (idparts,i)=>{
      var p = new Promise((resolve, reject)=>{
         return $.ajax({
            url: '/xapi/digital/v1/product/' + idparts +'?_customerState=GUEST&_regionCode=US&CurrencyCode=USD&_deviceType=DESKTOP&_shoppingMode=SITE&bigTicketCXHeaders=1&_application=SITE&'+new Date().getTime(),
        type: 'GET',
        dataType: 'JSON',
            success: function(data){
              // console.log('sucess',data)
              let dd = data;
              dd.product[0].id = idparts;
              // console.log('success---', idparts, dd);
              resolve(dd);
            },
        error: function(data){
              console.log('err', data);
              // return {}
              resolve({});
        }
          }).done((data)=>{
           let dd = data;
           dd.product[0].id = idparts;
           // console.log('done---', idparts, dd);
           resolve(dd);
         });
      })
    // };
      ajaxes.push(p);
    });
    //window.location.href.indexOf('mcom-128') > -1 || window.location.href.indexOf('localhost') > -1
    // if (true) {
      return new Promise(function(resolve, reject){
        // console.log('here');
        return Promise.all(ajaxes).then(function(data){
          console.log('ajaxes', data)
          var p = [];
          _.each(data, function(el,i){
            if (el.product){
              p = p.concat(el.product);
              self.model.set('featureEligible', el.product[0].detail.flags);
            }
            Properties.load(el.uiKillSwitches);
            self.model.set('uiKillSwitches', el.uiKillSwitches);
            // try {
            //
            // } catch(e){}
            // self.model.set('viewState',{detail: {selectedColor: color}});
            // PageApp.channel.trigger('update:selectedColor', {selectedColor: color});
            // console.log(self.model, color, '>>>>>>>> in product',  event.target);
            // if (el.uiKillSwitches && $('[data-bootstrap="page/product"]').length == 0) {
            //   let uiBootstrap = document.createElement('script');
            //   uiBootstrap.setAttribute('data-bootstrap','page/product');
            //   uiBootstrap.setAttribute('type','application/json');
            //   uiBootstrap.innerHTML = JSON.stringify({'properties':el.uiKillSwitches});
            //   document.body.appendChild(uiBootstrap)
            // }
          })
          self.model.set({list: {'product': p}});
          resolve({'product': p, color: color})
        })
      })
    // } else { //old
    //   return new Promise(function (resolve, reject) {
    //     $.ajax({
    //       // url: "/xapi/discover/v1/page?pathname=/shop/featured/"+event.target.dataset['pdpids']+",10916411,405497&_application=SITE&_navigationType=SEARCH&_deviceType=PC&_shoppingMode=SITE&_regionCode=US&_customerState=GUEST",
    //       url: '/xapi/digital/v1/product/' + event.target.dataset['pdpids']+'?_customerState=GUEST&_regionCode=US&CurrencyCode=USD&_deviceType=DESKTOP&_shoppingMode=SITE&bigTicketCXHeaders=1&_application=SITE',
    //       // url: "",
    //       type: 'GET',
    //       dataType: 'JSON',
    //       success: self.getProd2.bind(this, resolve, event),
    //       error: function(data){
    //         var d = self.parse(data, event.target.dataset['pdpids']);
    //         // self.model.set({list: d});
    //         resolve(d);
    //       }
    //     })
    //   })
    // }


    // return "";



    // var url1 = '/xapi/digital/v1/product/' + event.target.dataset['pdpids']+'?_customerState=GUEST&_regionCode=US&CurrencyCode=USD&_deviceType=DESKTOP&_shoppingMode=SITE&bigTicketCXHeaders=1&_application=SITE';
    // var url2 = '/xapi/discover/v1/product?productIds='+event.target.dataset['pdpids'];
    //

    // var ajax1 = $.ajax({
    //   url: '/xapi/digital/v1/product/' + event.target.dataset['pdpids']+'?_customerState=GUEST&_regionCode=US&CurrencyCode=USD&_deviceType=DESKTOP&_shoppingMode=SITE&bigTicketCXHeaders=1&_application=SITE',
    //   // url: "",
    //   type: 'GET',
    //   dataType: 'JSON',
    //   success: function(data){
    //     return data;
    //   },
    //   error: function(data){
    //     return {}
    //   }
    // }).done(function( data ) {
    //   return data;
    // });
    //
    // var ajax2 = $.ajax({
    //   url: '/xapi/discover/v1/product?productIds='+event.target.dataset['pdpids'],
    //   type: 'GET',
    //   dataType: 'JSON',
    //   success: function(data){
    //     return data;
    //   },
    //   error: function(data){
    //     return {}
    //   }
    // }).done(function( data ) {
    //   return data;
    // });
    //
    // return new Promise(function (resolve, reject) {
    //   $.when(ajax1, ajax2)
    //     .done((v1,v2)=>{
    //       // console.log(v1,v2);
    //
    //     // console.log('when', results[0], results[1]);
    //     // var p0=[],p1=[];
    //       var p0 = v1[0].product,
    //       p1 = v2[0].map((o)=>{return o.product});
    //     // results[0].done((data0) => {
    //     //   p0 = data0.product;
    //     //   // console.log(data0, 'here-----',p0);
    //     // });
    //     // results[1].done((data1) => {
    //     //   p1 = data1.map((o)=>{return o.product});
    //     //   // console.log(data1.product, 'here2-----',p1);
    //     // });
    //     // console.log('app',p0, p1);
    //     //
    //     $.each(p0, function(i,obj){
    //       var match = p1.filter((o)=>{ return obj.id == o.id});
    //       if (match.length > 0){
    //     //     console.log(match[0].availability,p0[i].availability, obj.id);
    //         p0[i].availability = _.merge(match[0].availability,p0[i].availability);
    //         try {
    //           console.log(match[0].traits.sizes,match[0].traits.colors);
    //           p0[i].traits = _.merge({
    //             colors:{
    //               selectedColor: match[0].traits.colors.selectedColor.id,
    //               colorMap: _.keyBy(match[0].traits.colors.colorMap, 'id'),
    //               orderedColorsById: [match[0].traits.colors.selectedColor.id],
    //               orderedColorsByName: [match[0].traits.colors.selectedColor.id]
    //             },
    //             sizes:{
    //               orderedSizesBySeqNumber: Object.keys(Object.assign({}, match[0].traits.sizes.sizeMap)),
    //               sizeMap: Object.assign({}, match[0].traits.sizes.sizeMap)
    //             }
    //           },p0[i].traits);
    //           console.log( p0[i].traits , obj.id );
    //         }catch(e){
    //
    //         }
    //
    //
    //       }
    //     //   if (i == p0.length-1){
    //     //     console.log(p0,'----combined');
    //     //   }
    //     });
    //     // resolve([]);
    //     //   var merged = _.merge(p0,p1);
    //       console.log(p0,'merged----');
    //       self.model.set({list: {product: p0}});
    //       resolve({product: p0});
    //       return p0;
    //
    //     })
    //   // .then((a1, a2)=>{
    //   //   console.log('in the then',a1, a2)
    //   // })
    // })
    // console.log('-----p',p);
    // return {};
    // var promises = [a];
    // return new Promise.all([ajax1,ajax2]).then(function(d){
    //
    // })


  }

  getProd2(resolve, event, data){
    console.log(resolve, event, data, arguments)
    var d = self.parse(data, event.target.dataset['pdpids']);
    self.model.set({list: d});
    arguments[0](d);
  }


  getPros(ids, type){
    // console.log('getPros', ids)
    var vid =  "499cee80499ce1d0499ca540499c6f50";
    if (typeof utag_data != 'undefined') {
      if (utag_data['cp.RTD']) {
        vid = utag_data['cp.RTD'];
      }
    }
    return new Promise(function (resolve, reject) {
      $.ajax({
        url:'/sdp/rto/request/recommendations',
        type: 'POST',
        timeout: 2000,
        // retryLimit : 3,
        "data": {
          "productType": type,
          // "noDefaultRecs": true,
          "requester": "MCOM-NAVAPP",
          "context": ids == -9 ? "ZSR_ZONE_B" : "PDP_ZONE_B",
          "maxRecommendations": "4",
          "visitorid": vid,
          "productId": typeof ids == 'string' ? ids.split(',')[0] : -9,
          "zone": ids == -9 ? "ZSR_ZONE_B" : "PDP_ZONE_B",
        },
        dataType: "JSON",
        success: function(data){
          if (data.recommendedItems.length > 0) {
            resolve(self.getProducts({target:{dataset: {pdpids: data.recommendedItems.map(function(o){ return o.productId })
            }}}))
          } else {
            resolve({product: []});
          }
        },
        error: function(data){
          resolve({product: []})
        }
      }).done(function(data){
        resolve({product: []})
      })
    })
  }

  parse(data, ids){
    console.log('inparse----',data,ids);
    var product = {};
    if (typeof data == 'string' && data.indexOf('{"product":') > -1) {
      product = JSON.parse(data);
    } else if (typeof data.product != 'undefined') {
      // _.each(data.product,function(el,i){
      //   //set all to true
      //   // if (!el.availability.available) {
      //   //   data.product[i].availability.available = true;
      //   // }
      // });
      product = data;

      // console.log(this.$window);
      // if (this.$window.location.hostname.indexOf('macys.com') > -1) {
      //   //production
      //   if (data.product.length == 1) {
      //     if (!data.product[0].availability.available || !data.product[0].pricing){
      //       // console.log('single not found')
      //       product = this.getPros(ids, data.product[0].detail.typeName);
      //     } else {
      //       // console.log('single found')
      //       product = data
      //     }
      //   } else {
      //     if (data.product.filter(function(p){ return p.availability.available || p.pricing }).length > 0) {
      //       // console.log('multi found')
      //       product = data
      //     } else {
      //       // console.log('multi not found')
      //       product = this.getPros(ids, data.product[0].detail.typeName);
      //     }
      //   }
      // } else {
      //   //non prod - no recommendations
      //   product = data
      // }

    }  else {
      // console.log('no product');
      // product = {product: []};
      // if (this.$window.location.hostname.indexOf('macys.com') > -1) {
      //   product = this.getPros(-9);
      // } else {
        product = {product: []};
      // }
    }
    return product;
  }

  buildcolor(model){
    if (model.color) {
      try {
        model.product[0].traits.colors.selectedColor = model.color;
        let selected = model.product[0].traits.colors.colorMap[model.color].imagery;
        model.product[0].imagery = selected;
        // model.set('viewState').imagery
        let getViewState = self.model;
        console.log('buildProductDetailsPage>>>>>',model, getViewState, 'pdp', self.model.get('product'));
        model.selectedColor = selected;
        // setTimeout(function(){
        //   console.log('color-swatch-div>>>>', $('.color-swatch-div[data-color-id="'+model.color+'"]'))
        //   $('.color-swatch-div[data-color-id="'+model.color+'"]').addClass('selected');
        // },250)

      } catch(e){
        console.log('errr>>>>>', e)
      }
    }
  }

  buildProductDetailsPage(model) {
    self.buildcolor(model);
    PageApp.channel.trigger(ProductDetailsActions.product.view.update, {
      el: '.shop-the-look-bottom',
      model: model
    });
    // $('.color-swatch-div[data-color-id="'+model.color+'"]').click()


  }

  appender(container, el, view){
    if (container) {
      $(container).append(el);
    } else {
      $('#pdp-horizontal-holder .componentCarousel.slide-show').next().replaceWith(el);

    }
  }

  linking(content){
    if (content) {
      $('.pdp [data-el="accordion"]').after('<div class="pdp-fulldt"><a class="secondary button" href="/shop/product/?ID=' + content.id + '&lid='+utag_data.page_name
        +'_shopthelook">View full details</a></div>');
      if (document.querySelectorAll('[data-type="shop-collection"]').length > 0) {
        $('[data-type="shop-collection"]').attr('href', '/shop/product/?ID=' + content.id + '&lid='+utag_data.page_name+'_shopthelook')
      }
    }
  }
  brightcoveappend(){
    videojs = null;
    bc = null;
    var script2 = document.createElement("script");
    script2.src= "https://players.brightcove.net/24953835001/r1Lf66yc_default/index.min.js";
    $('.pdp').append(script2);
    self.brightcove();
    // $()
  }
  brightcove() {
    if ( $('[data-el="media"]').find('video').length > 0 ){
      // console.log('here');
      setTimeout(function(){
        self.player( $('[data-el="media"]').find('video').attr('id') )
      }, 1000)
    } else {
    }
  }

  colorg(model,productModel){
    console.log('colorg', model, productModel)
    if (model.color) {
      if (productModel.get('viewState')) {
        try {
          if (productModel.get('viewState').traits.color.swatchTiers[0].swatches) {
            let swatches = productModel.get('viewState').traits.color.swatchTiers[0].swatches;
            for (let i = 0; i < swatches.length; i++){
              if (swatches[i].id == model.color) {
                swatches[i].isSelected = true
              } else {
                try {
                  delete swatches[i].isSelected
                } catch(e){}
              }
            }
          }
        } catch(e){}
      }
    }
  }

  async updateProd({
    el,
    container,
    model,
  }){

    let productModel = new ProductModel(model, {parse: true});
    // productModel.set('clientSideExperimentationFlags', {});
    console.log('update view', productModel, productModel.get('viewState'), model.color);
    productModel.set('clientSideExperimentationFlags', clientSideExperimentationFlags(productModel));
    productModel.set('uiKillSwitches', {});
    self.colorg(model, productModel);
    if (productModel.get('product')) {
      productModel.set('featureEligible', Object.assign({
        truefitEligible: false,
        accordions: true,
        productDetailsStandAlone: true,
        reviewsSummary: true,
        // creditFinance: productModel.get('product').detail.klarna,
      }, productModel.get('product').detail.flags));
    }



    getProductView(productModel.get('product'), productModel.get('viewState')).then(({default: ProductView}) => {
      const productView = new ProductView({model: productModel});
      self.appender(container,productView.$el);
      productView.render();
      if ($('[data-el="alternate-images"]').size() > 0) {
        $('[data-el="main-image"]').append('<div class="carousel-chevron prev"><button class="m-carousel-button prev shop-the-look-pdp-button disabled"><span class="icon-back-lg-small"></span></button></div><div class="carousel-chevron next"><button class="m-carousel-button next shop-the-look-pdp-button"><span class="icon-front-lg-small"></span></button></div>');
      }
      $('.vw-collection').addClass('vw-collection-1').removeClass('vw-collection');
      $('.vw-collection-1 a').attr('href', '/shop/product/?ID='+productModel.get('product').id);
      // $('.vw-collection-1 a').on({click:function(){
      //   window.open('/shop/product/?ID='+productModel.get('product').id);
      // }})
      self.linking(productModel.get('product'));
      var data = Object.assign({}, productModel.get('utagData'));
      try {
        if (Object.keys(data).length === 0) {
          data = {
            // "is_responsive_pdp": "true",
            // "eligible_attribute_count": "zero",
            // "page_type": "sitelet",
            "t_category_id": [
              productModel.get('product').relationships.taxonomy.defaultCategoryId.toString()
            ],
            "t_category_name": [
              productModel.get('product').detail.typeName
            ],
            "is_big_ticket": [
              productModel.get('product').detail.flags.bigTicketItem.toString()
            ],
            "is_big_ticket_v2c": [
              productModel.get('product').detail.flags.bigTicketV2CItem.toString()
            ],
            "product_id": [
              productModel.get('product').id.toString()
            ],
            // "product_low_availability": [
            //   "false"
            // ],
            // "product_availability_message": [
            //   "This product is currently unavailable"
            // ],
            "product_name": [
              productModel.get('product').detail.name
            ],
            // "product_type": [
            //   "single item"
            // ],
            // "product_original_price": [
            // ],
            // "product_price": [
            // ],
            // "product_pricing_state": [
            //   ""
            // ],
            // "product_rating": [
            //   productModel.get('product').reviewStatistics"3.6667"
            // ],
            // "product_reviews": [
            //   "3"
            // ],
            // "product_video": [
            //   "false"
            // ],
            // "product_gwp_available": [],
            // "product_pwp_available": [],
            // "true_fit_eligible": [
            //   "true"
            // ],
            // "findation_eligible": [
            //   "false"
            // ],
            "product_brand": [
              productModel.get('product').detail.brand.name
            ],
            // "consolidated_product": "false",
            // "gdp_eligible": "false",
            // "event_name": "shop the look"
          }
          if (productModel.get('product').pricing) {
            try {
              productModel.get('product').pricing.price.tieredPrice.forEach((p) => {
                if (p.values[0].type == 'regular') {
                  data.product_price = [p.values[0].value.toString()]
                } else if (p.values[0].type == 'discount') {
                  data.product_original_price = data.product_price;
                  data.product_price = [p.values[0].value.toString()];
                }
              })
              if (productModel.get('product').pricing.price.finalPrice) {
                data.product_original_price = data.product_price;
                data.product_price = [productModel.get('product').pricing.finalPrice.values[0].value];
              }
            } catch (e) {
            }

          }
        }
      }catch(e){
        // console.log(e,'err in trakcing', e)
      };
      var newData = Object.assign(data, {
        page_type: 'sitelet',
        event_name: 'shop the look',
      });
      // console.log('utagData', data, productModel, model);
      videojs = null;
      bc = null;
      var script2 = document.createElement("script");
      script2.src= "https://players.brightcove.net/24953835001/r1Lf66yc_default/index.min.js";
      $('.pdp').append(script2);
      self.brightcove();
      TagManager.fireTag('link', newData);
      self.model.set({pdp: productModel});

      try {
        PageApp.channel.on(`${ProductDetailsActions.product.alternateImage.update}:${productModel.get('product').id}`, self.hideArrow);

      PageApp.channel.on(`${ProductDetailsActions.product.alternateImage.update}:${productModel.get('product').id}`, self.zoomerset);
      } catch(e){}

      // PageApp.channel.on(`${ProductDetailsActions.product.alternateImage.update}:${productModel.get('product').id}`, function(){setTimeout((function(arg){self.zoomer(arguments[0])})(arguments),500)} );

    });
  }


  player(id) {
    if (bc && id) {
      window.myPlayer = bc(id);
    }
  }

  altImg(event){
    if (event.target.classList.contains('shop-the-look-pdp-button')) {
      var $selected = $('.alt-img.selected');
        if (bc) {
          if (bc.videojs.getAllPlayers().length > 0) {
            bc.videojs.getAllPlayers()[0].pause();
          }
        }
      if (event.target.classList.contains('next')){
        $selected.next().click();
      } else {
        $selected.prev().click();
      }
    } else {

    }
  }

  hideArrow(ind) {
    try {
      if (document.querySelector('[data-el="alternate-images"]').querySelectorAll('.scroller-wrp').length
        == 0) {
        $('.shop-the-look-pdp-button.prev').addClass('disabled');
        $('.shop-the-look-pdp-button.next').addClass('disabled');
      } else if (ind == 'ELEMENT_TAG') {
        $('.shop-the-look-pdp-button.prev').addClass('disabled');
        $('.shop-the-look-pdp-button.next').removeClass('disabled');
      } else if (ind == $('.alt-img.selected').attr('aria-setsize') - 1) {
        $('.shop-the-look-pdp-button.next').addClass('disabled');
        $('.shop-the-look-pdp-button.prev').removeClass('disabled');
      } else if (ind == 0) {
        $('.shop-the-look-pdp-button.prev').addClass('disabled');
        $('.shop-the-look-pdp-button.next').removeClass('disabled');
      } else {
        $('.shop-the-look-pdp-button.prev').removeClass('disabled');
        $('.shop-the-look-pdp-button.next').removeClass('disabled');
      }
    } catch(e){
      $('.shop-the-look-pdp-button.prev').addClass('disabled');
      $('.shop-the-look-pdp-button.next').addClass('disabled');
    }
    // console.log('ARR', self, this);
  }

  zoomerset(ind){
    setTimeout(self.zoomer.bind(this,ind),200)
  }
  zoomer(ind){
    // console.log('zoomer', ind);
    var $scrlimgm = $('.main-img[data-index="' + ind + '"]');
      var $scrlimgin = $scrlimgm.first();
      if (ind != 0) {
        $scrlimgin = $scrlimgm.last();
      }
      if ( $scrlimgm.find('picture').size() > 0 ) {
        var src = $scrlimgm.find('picture').find('img').attr('src').replace('wid=500&hei=613', 'wid=1230&hei=1500');
        $scrlimgin.append($('.zoomer-image').attr('src', src));
      }
  }

  // success(data){
  //   // console.log('sucess',data)
  //   resolve(data);
  // }
}


// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/src/shop-the-look-pdp.js